import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// Misma ficha que /padres, pero con el token en la ruta (/padres/<token>/): así la app instalada
// en la pantalla de inicio abre SIEMPRE la ficha de su hijo/a, sin que la familia tenga que pegar
// el link (el manifest se sirve en /padres/<token>/manifest.webmanifest y su start_url relativo
// conserva el token — ver firebase.json y manifest-padres.json). El link viejo con ?t= sigue
// funcionando y se redirige solo a esta forma.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/padres/$token",
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: lazyRouteComponent(() => import("./kidstenia-page"), "KidsteniaPage"),
});
